import { render, staticRenderFns } from "./myPopoverWorker.vue?vue&type=template&id=0d487b67&"
import script from "./myPopoverWorker.vue?vue&type=script&lang=js&"
export * from "./myPopoverWorker.vue?vue&type=script&lang=js&"
import style0 from "./myPopoverWorker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports